import { Users, MessageSquare, Shield, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import DiscordIcon from "@/components/DiscordIcon";

const DISCORD_BLUE = "#5865F2";

export default function Community() {
  return (
    <div className="max-w-3xl mx-auto" data-testid="community-page">
      {/* Header */}
      <Link to="/dashboard" className="flex items-center gap-1.5 mb-5 text-sm transition hover:opacity-80" style={{ color: "var(--text-muted)" }} data-testid="community-back-link">
        <ArrowLeft size={14} /> Back
      </Link>
      <h1 className="h-display text-3xl sm:text-4xl">Discord Community</h1>
      <p className="text-sm mt-2 mb-8" style={{ color: "var(--text-muted)" }}>
        Our private community is being built — you&apos;ll get access shortly.
      </p>

      {/* Main card */}
      <div className="surface-card p-6 sm:p-8" data-testid="community-main-card">
        {/* Top row: Discord avatar + title */}
        <div className="flex items-center gap-4 mb-7">
          <div
            className="shrink-0 flex items-center justify-center rounded-2xl"
            style={{
              width: 64,
              height: 64,
              background: DISCORD_BLUE,
              color: "#ffffff",
            }}
          >
            <DiscordIcon size={34} />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="h-display text-2xl">Discord Account</h2>
            <p className="text-sm mt-0.5" style={{ color: "var(--text-muted)" }}>
              Launching soon
            </p>
          </div>
          <span
            className="font-mono text-[11px] uppercase tracking-wider px-3 py-1.5 rounded-full whitespace-nowrap"
            style={{ background: "var(--lime-glow)", color: "var(--lime)", border: "1px solid var(--lime)" }}
            data-testid="community-coming-soon-badge"
          >
            Coming Soon
          </span>
        </div>

        {/* Feature cards */}
        <div className="space-y-3 mb-6">
          <FeatureCard icon={Users} title="Join Community" description="Connect with peers" />
          <FeatureCard icon={MessageSquare} title="Direct Access" description="Chat with the coaching team" />
          <FeatureCard icon={Shield} title="Exclusive Channels" description="Deal reviews, scripts, wins" />
        </div>

        {/* CTA */}
        <div
          className="w-full flex items-center justify-center gap-3 text-base py-4 rounded-2xl font-semibold cursor-not-allowed"
          style={{ background: "var(--surface2)", color: "var(--text-muted)", border: "1px solid var(--border)" }}
          data-testid="community-join-button"
        >
          <DiscordIcon size={20} /> Coming Soon
        </div>
        <p className="text-xs text-center mt-3" style={{ color: "var(--text-dim)" }}>
          We&apos;ll post the invite link here the moment it opens up.
        </p>
      </div>
    </div>
  );
}

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div
      className="flex flex-col items-center justify-center text-center p-6 rounded-2xl"
      style={{
        background: "var(--surface2)",
        border: "1px solid var(--border)",
      }}
    >
      <div
        className="flex items-center justify-center mb-3"
        style={{
          width: 36,
          height: 36,
          color: "var(--lime)",
        }}
      >
        <Icon size={28} strokeWidth={1.75} />
      </div>
      <div className="font-bold text-base">{title}</div>
      <p className="text-sm mt-0.5" style={{ color: "var(--text-muted)" }}>{description}</p>
    </div>
  );
}
